var exports = {
  "vW": "SlashCommandParamBar.module__inner___OXFJbV",
  "Qq": "SlashCommandParamBar.module__text___OXFJbV",
  "UU": "SlashCommandParamBar.module__name___OXFJbV",
  "h_": "SlashCommandParamBar.module__description___OXFJbV",
  "ku": "SlashCommandParamBar.module__requiredError___OXFJbV" + " " + "SlashCommandParamBar.module__description___OXFJbV",
  "ne": "SlashCommandParamBar.module__controls___OXFJbV",
  "x6": "SlashCommandParamBar.module__button___OXFJbV",
  "Kk": "SlashCommandParamBar.module__icon___OXFJbV",
};

module.exports = exports;
